export enum Hero {
    Hendalf = 'hendalf',
    MaxFry = 'maxfry',
    HarryPotter = 'harrypotter',
    Charmed = 'charmed',
    Pifiya = 'pifya',
    BabaYaga = 'babayaga'
}

export const question = (text: string, options: [string, string][], icon: string) => ({
    text,
    options: options.map(opt => ({label: opt[1], value: opt[0]})),
    icon
});

export const Results: Record<Hero, string> = {
    [Hero.BabaYaga]: 'Баба-Яга',
    [Hero.Hendalf]: 'Гендальф',
    [Hero.MaxFry]: 'Макс Фрай',
    [Hero.HarryPotter]: 'Гарри Поттер',
    [Hero.Charmed]: 'Зачарованная',
    [Hero.Pifiya]: 'Пифия'
};

export const QUESTIONS = [
    question('Где ты живёшь?', [
        [Hero.BabaYaga, 'В лесной чаще'],
        [Hero.Hendalf, 'Я странник, дорога — мой дом'],
        [Hero.MaxFry, 'В доме с башней, увитой плющём'],
        [Hero.Charmed, 'Бабушка-ведьма оставила мне домик в Сан-Франциско'],
        [Hero.Pifiya, 'Я часто меняю место жительства, но разве это важно, если мы все — часть одной Матрицы?'],
        [Hero.HarryPotter, 'У меня два дома: один в мире людей, где я прикидываюсь обычном человеком, второй в ' +
        'волшебном мире, где я часть волшебного сообщества']
    ], 'home'),
    question('Чем ты питаешься?', [
        [Hero.BabaYaga, 'Детьми и прочими людишками, забредающими в мою чащу'],
        [Hero.Hendalf, 'Могу есть, могу не есть, не физическое тело даёт мне сил '],
        [Hero.MaxFry, 'Ооо, я знатный гурман, не пройду мимо ни одного трактира. Вместо кофе пью зелья'],
        [Hero.Charmed, 'Да то же, что и все: иногда дома готовлю, иногда пиццу или роллы заказываю'],
        [Hero.Pifiya, 'Люблю печеньки, лимонад и сигареты'],
        [Hero.HarryPotter, 'Сэндвичи, кексы и сливочное пиво']
    ], 'wood'),
    question('Держишь ли питомцев?', [
        [Hero.BabaYaga, 'А то! изба у меня живая, гуси на службе и три всадника'],
        [Hero.Hendalf, 'Нет, но мне часто помогаютмои друзья - Орлы'],
        [Hero.MaxFry, 'Ага, домашнюю Химеру'],
        [Hero.Charmed, 'Люблю классику -  чёрный кот-фамильяр'],
        [Hero.Pifiya, 'Предпочитаю телохранителей и помощниц'],
        [Hero.HarryPotter, 'Сову']
    ], 'fish'),
    question('Любимая одежда?', [
        [Hero.BabaYaga, 'Платье из крапивы, мухоморные бусы на шее'],
        [Hero.Hendalf, 'Дорожный плащ и шляпу'],
        [Hero.MaxFry, 'Тюрбан и мантию смерти'],
        [Hero.Charmed, 'Самые последние тренды модного мира'],
      [Hero.Pifiya, 'Когда готовлю — надеваю фартук, в дорогу беру сумку и перчатки. Словом, люблю  практичность ' +
        'и комфорт '],
        [Hero.HarryPotter, 'В мире людей - джинсы, в мире волшебства - мантию ']
    ], 'shoes'),
    question('Чем ты занимаешься?', [
        [Hero.BabaYaga, 'Сторожу границу мира живых и мёртвых'],
        [Hero.Hendalf, 'Странствую'],
        [Hero.MaxFry, 'Состою на службе тайного магического сыска'],
        [Hero.Charmed,
            'Небольшой бизнес: все мы живём в материальном мире, магия-магией, а стабильный доход — это важно'],
        [Hero.Pifiya, 'Наблюдаю за людьми, за миром'],
        [Hero.HarryPotter, 'Учусь']
    ], 'plant'),
    question('Кому ты помогаешь?', [
        [Hero.BabaYaga, 'Путникам, оказывающим должное почтение, мне и моей силе'],
        [Hero.Hendalf, 'Народам, странам и континентам'],
        [Hero.MaxFry, 'Балансу миров и любимому городу'],
        [Hero.Charmed, 'Невинным людям'],
        [Hero.Pifiya, 'Детям и избранным'],
        [Hero.HarryPotter, 'Себе, своим друзьям и тем, кого люблю']
    ], 'deer'),
    question('Какая твоя суперсила?', [
        [Hero.BabaYaga,
            'Знаю все пути-дороги, повелеваю кикиморами и лешими, и ещё у меня целый сарай всяких волшебных штук!'],
        [Hero.Hendalf, 'Повелеваю огнём и светом'],
        [Hero.MaxFry, 'Плююсь ядом, гуляю между мирами'],
      [Hero.Charmed, 'Люблю полезную в быту магию: двигаю предметы, останавливаю время, перемещаюсь в пространстве'],
        [Hero.Pifiya, 'Вижу будущее'],
        [Hero.HarryPotter, 'Кажется никакая, или может - любовь?']
    ], 'hat'),
    question('Какой твой волшебный инструмент?', [
        [Hero.BabaYaga,
            'Ступа и метла'],
        [Hero.Hendalf, 'Посох'],
        [Hero.MaxFry, 'У меня есть волшебный меч и он прямо в моём сердце. Во втором из них'],
        [Hero.Charmed, 'Книга заклинаний'],
        [Hero.Pifiya, 'Хороший разговор — моё главное волшебство'],
        [Hero.HarryPotter, 'Волшебная палочка']
    ], 'skewer')
];
